import React from 'react';
import styled from 'styled-components';
import { fontSizes, primaryColor } from '../constants/globalstyles';

const Tabs = props => {
  // Support both old and new prop patterns
  const { tabs, activeTab, onTabChange, options, selected, onSelect, borderbottom, tabExtras } =
    props;

  // Determine which pattern is being used
  const isNewPattern = options && typeof selected === 'number' && onSelect;
  const isOldPattern = tabs && activeTab && onTabChange;

  if (!isNewPattern && !isOldPattern) {
    console.warn(
      'Tabs component: Invalid props provided. Please use either the new pattern (options, selected, onSelect) or the old pattern (tabs, activeTab, onTabChange)'
    );
    return null;
  }

  // Handle new pattern (options, selected, onSelect)
  if (isNewPattern) {
    return (
      <TabContainer>
        <TabBar borderbottom={borderbottom}>
          {options?.map((option, index) => (
            <Tab key={index} selected={selected === index} onClick={() => onSelect(index)}>
              <TabText>{option}</TabText>
              {tabExtras && tabExtras[index] ? tabExtras[index] : null}
            </Tab>
          ))}
        </TabBar>
      </TabContainer>
    );
  }

  const normalizedTabs = Array.isArray(tabs) ? tabs.filter(Boolean) : [];

  // Handle old pattern (tabs, activeTab, onTabChange)
  return (
    <TabContainer>
      <TabBar borderbottom={borderbottom}>
        {normalizedTabs.map((tab, index) => (
          <Tab
            key={tab.name || `tab-${index}`}
            selected={activeTab === tab.name}
            onClick={() => onTabChange(tab.name)}
          >
            <TabText>{tab.label}</TabText>
          </Tab>
        ))}
      </TabBar>
      <TabContent>{normalizedTabs.find(tab => tab.name === activeTab)?.content}</TabContent>
    </TabContainer>
  );
};

const TabContainer = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: visible;
`;

const TabBar = styled.div`
  width: 100%;
  display: flex;
  padding-left: 20px;
  padding-top: 10px;
  border-bottom: ${props => (props.borderbottom ? `1px solid #dfdfdf` : 'none')};
  overflow-x: auto;
  min-width: 0;
`;

const Tab = styled.div`
  margin-right: 30px;
  border-bottom: ${props => (props.selected ? `2px solid ${primaryColor}` : '')};
  line-height: 25px;
  cursor: pointer;
  flex-direction: row;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 0;
`;

const TabText = styled.div`
  font-style: normal;
  font-weight: 400;
  margin-bottom: 2px;
  font-size: ${fontSizes.medium};
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TabContent = styled.div`
  padding: 20px;
  width: 100%;
  max-width: 100%;
  overflow: visible;
`;

export default Tabs;
